import html2pdf from "html2pdf.js";
import LogoMittsure from "../newLogo2204.PNG";

const OlympiadClubbingPdf = (data) => {

    console.log("Generating PDF with data:", data);

    if (!data) return;

    // =========================
    // Financial Year
    // =========================
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = currentDate.getMonth() + 1;

    let fyStartYear;
    let fyEndYear;

    if (month >= 4) {
        fyStartYear = year;
        fyEndYear = year + 1;
    } else {
        fyStartYear = year - 1;
        fyEndYear = year;
    }

    const fiscalYearRange = `${fyStartYear}-${String(fyEndYear).slice(-2)}`;

    // =========================
    // Helpers
    // =========================
    const safe = (val) => {
        return val !== undefined &&
            val !== null &&
            val !== ""
            ? val
            : "-";
    };

    const currency = (val) => {
        return `₹${Number(val || 0).toLocaleString("en-IN")}`;
    };

    const formatDate = (date) => {

        if (!date) return "-";

        return new Date(date).toLocaleDateString("en-IN", {
            day: "2-digit",
            month: "short",
            year: "numeric"
        });
    };

    // =========================
    // Dynamic Subject Map
    // =========================
    const subjectMap = {
        science: "Science",
        maths: "Maths",
        mathsmatics: "Maths",
        english: "English",
        reasoning: "Reasoning",
        "gk_iq": "GK & IQ",
        gk: "GK & IQ",
        iq: "GK & IQ"
    };

    // =========================
    // Registration Data
    // =========================
    const registrations = data?.registrations || [];

    // =========================
    // Student Summary
    // =========================
    const studentSummary = {};

    registrations.forEach((reg) => {

        (reg?.allRegistrationLineItemes || []).forEach((item) => {

            const className = item?.class_name || "N/A";
            const subjectName = (item?.subject_name || "").toLowerCase();

            if (!studentSummary[className]) {
                studentSummary[className] = {
                    class: className,
                    subjects: {}
                };
            }

            studentSummary[className].subjects[subjectName] =
                Number(item?.student || 0);
        });
    });

    // =========================
    // Study Material Summary
    // =========================
    const studySummary = {};

    registrations.forEach((reg) => {

        (reg?.allRegistrationLineItemes || []).forEach((item) => {

            const className = item?.class_name || "N/A";
            const subjectName = (item?.subject_name || "").toLowerCase();

            if (!studySummary[className]) {
                studySummary[className] = {
                    class: className,
                    subjects: {}
                };
            }

            studySummary[className].subjects[subjectName] =
                Number(item?.study_material || 0);
        });
    });

    // =========================
    // Get All Subjects Dynamically
    // =========================
    const allSubjects = new Set();

    registrations.forEach((reg) => {

        (reg?.allRegistrationLineItemes || []).forEach((item) => {

            if (item?.subject_name) {
                allSubjects.add(item.subject_name);
            }
        });
    });

    const subjectList = [...allSubjects];

    // =========================
    // Sort Class
    // =========================
    const sortByClass = (a, b) => {

        const getClassNumber = (cls) =>
            parseInt(String(cls || "").replace(/[^0-9]/g, "")) || 0;

        return getClassNumber(a.class) - getClassNumber(b.class);
    };

    // =========================
    // Student Rows
    // =========================
    const studentRows = Object.values(studentSummary)
        ?.sort(sortByClass)
        ?.map((row) => {

            return `
                <tr>
                    <td style="padding:6px;">
                        ${safe(row?.class)}
                    </td>

                    ${subjectList.map((subject) => {

                        const val =
                            row?.subjects?.[subject.toLowerCase()] || 0;

                        return `
                            <td style="padding:6px; text-align:center;">
                                ${val}
                            </td>
                        `;
                    }).join("")}
                </tr>
            `;
        })
        ?.join("");

    // =========================
    // Study Rows
    // =========================
    const studyRows = Object.values(studySummary)
        ?.sort(sortByClass)
        ?.map((row) => {

            return `
                <tr>
                    <td style="padding:6px;">
                        ${safe(row?.class)}
                    </td>

                    ${subjectList.map((subject) => {

                        const val =
                            row?.subjects?.[subject.toLowerCase()] || 0;

                        return `
                            <td style="padding:6px; text-align:center;">
                                ${val}
                            </td>
                        `;
                    }).join("")}
                </tr>
            `;
        })
        ?.join("");

    // =========================
    // Transactions
    // =========================
    const transactionRows = registrations
        ?.flatMap((reg) => reg?.AllTransactions || [])
        ?.map((txn, index) => {

            return `
                <tr>
                    <td style="padding:6px;">
                        ${index + 1}
                    </td>

                    <td style="padding:6px;">
                        ${safe(txn?.transactionReference)}
                    </td>

                    <td style="padding:6px;">
                        ${safe(txn?.payment_mode)}
                    </td>

                    <td style="padding:6px;">
                        ${formatDate(txn?.transactionDate)}
                    </td>

                    <td style="padding:6px;">
                        ${currency(txn?.paidAmount)}
                    </td>

                    <td style="padding:6px;">
                        ${safe(txn?.transactionStatus)}
                    </td>
                </tr>
            `;
        })
        ?.join("");

    // =========================
    // Coordinator Rows
    // =========================
    const coordinatorRows = data?.overAllCordinators
        ?.map((item, index) => {

            return `
                <tr>
                    <td style="padding:6px;">
                        ${index + 1}
                    </td>

                    <td style="padding:6px;">
                        ${safe(item?.subject)}
                    </td>

                    <td style="padding:6px;">
                        ${safe(item?.name)}
                    </td>

                    <td style="padding:6px;">
                        ${safe(item?.mobile)}
                    </td>

                    <td style="padding:6px;">
                        ${safe(item?.role)}
                    </td>
                </tr>
            `;
        })
        ?.join("");

    // =========================
    // HTML
    // =========================
    const htmlContent = `
        <div style="padding:15px; font-family:Arial; color:#000; font-size:12px;">

            <!-- HEADER -->
            <div style="display:flex; justify-content:space-between; align-items:center; margin-bottom:15px;">

                <img
                    src="${LogoMittsure}"
                    style="width:150px; object-fit:contain;"
                />

                <div style="text-align:right;">
                    <p style="margin:0;">
                        <b>Date:</b> ${formatDate(new Date())}
                    </p>

                    <p style="margin-top:5px;">
                        <b>Party ID:</b> ${safe(data?.partyId)}
                    </p>
                </div>
            </div>

            <!-- TITLE -->
            <h2 style="text-align:center; margin:0;">
                Mittsure Technologies LLP
            </h2>

            <h3 style="text-align:center; margin:5px 0 20px 0;">
                Olympiad Registration Summary (${fiscalYearRange})
            </h3>

            <!-- SCHOOL INFO -->
            <table border="1" style="width:100%; border-collapse:collapse; margin-bottom:15px;">

                <tr>
                    <td style="padding:6px;">
                        <b>School Name:</b>
                        ${safe(data?.schoolName)}
                    </td>

                    <td style="padding:6px;">
                        <b>Total Registrations:</b>
                        ${safe(data?.totalRegistrations)}
                    </td>
                </tr>

                <tr>
                    <td style="padding:6px;">
                        <b>Total Students:</b>
                        ${safe(data?.overAllStudents)}
                    </td>

                    <td style="padding:6px;">
                        <b>Total Study Material:</b>
                        ${safe(data?.overAllStudyMaterial)}
                    </td>
                </tr>

                <tr>
                    <td style="padding:6px;">
                        <b>Total Paid:</b>
                        ${currency(data?.overAllPaid)}
                    </td>

                    <td style="padding:6px;">
                        <b>Total Pending:</b>
                        ${currency(data?.overAllPending)}
                    </td>
                </tr>

            </table>

            <!-- STUDENT SUMMARY -->
            <h3 style="margin-bottom:5px;">
                Student Registration Summary
            </h3>

            <table border="1" style="width:100%; border-collapse:collapse; margin-bottom:15px;">

                <tr>
                    <th style="padding:6px;">Class</th>

                    ${subjectList.map((subject) => `
                        <th style="padding:6px;">
                            ${subject}
                        </th>
                    `).join("")}
                </tr>

                ${studentRows || `
                    <tr>
                        <td colspan="${subjectList.length + 1}"
                            style="padding:10px; text-align:center;">
                            No Data Available
                        </td>
                    </tr>
                `}
            </table>

            <!-- STUDY MATERIAL -->
            <h3 style="margin-bottom:5px;">
                Study Material Summary
            </h3>

            <table border="1" style="width:100%; border-collapse:collapse; margin-bottom:15px;">

                <tr>
                    <th style="padding:6px;">Class</th>

                    ${subjectList.map((subject) => `
                        <th style="padding:6px;">
                            ${subject}
                        </th>
                    `).join("")}
                </tr>

                ${studyRows || `
                    <tr>
                        <td colspan="${subjectList.length + 1}"
                            style="padding:10px; text-align:center;">
                            No Data Available
                        </td>
                    </tr>
                `}
            </table>

            <!-- PAYMENT SUMMARY -->
            <h3 style="margin-bottom:5px;">
                Payment Summary
            </h3>

            <table border="1" style="width:100%; border-collapse:collapse; margin-bottom:15px;">

                <tr>
                    <th style="padding:6px;">Total Amount</th>
                    <th style="padding:6px;">Paid Amount</th>
                    <th style="padding:6px;">Pending Amount</th>
                </tr>

                <tr>
                    <td style="padding:6px;">
                        ${currency(data?.overAllAmount)}
                    </td>

                    <td style="padding:6px;">
                        ${currency(data?.overAllPaid)}
                    </td>

                    <td style="padding:6px;">
                        ${currency(data?.overAllPending)}
                    </td>
                </tr>

            </table>

            <!-- TRANSACTION SUMMARY -->
            <h3 style="margin-bottom:5px;">
                Transaction Details
            </h3>

            <table border="1" style="width:100%; border-collapse:collapse; margin-bottom:15px;">

                <tr>
                    <th style="padding:6px;">#</th>
                    <th style="padding:6px;">Reference No.</th>
                    <th style="padding:6px;">Payment Mode</th>
                    <th style="padding:6px;">Date</th>
                    <th style="padding:6px;">Amount</th>
                    <th style="padding:6px;">Status</th>
                </tr>

                ${transactionRows || `
                    <tr>
                        <td colspan="6"
                            style="padding:10px; text-align:center;">
                            No Transactions Available
                        </td>
                    </tr>
                `}
            </table>

            <!-- COORDINATOR -->
            <h3 style="margin-bottom:5px;">
                Coordinators
            </h3>

            <table border="1" style="width:100%; border-collapse:collapse;">

                <tr>
                    <th style="padding:6px;">#</th>
                    <th style="padding:6px;">Subject</th>
                    <th style="padding:6px;">Name</th>
                    <th style="padding:6px;">Mobile</th>
                    <th style="padding:6px;">Role</th>
                </tr>

                ${coordinatorRows || `
                    <tr>
                        <td colspan="5"
                            style="padding:10px; text-align:center;">
                            No Coordinators Available
                        </td>
                    </tr>
                `}
            </table>

        </div>
    `;

    // =========================
    // Generate PDF
    // =========================
    const element = document.createElement("div");

    element.innerHTML = htmlContent;

    html2pdf()
        .set({
            margin: 5,
            filename: `Olympiad_${safe(data?.partyId)}.pdf`,
            image: {
                type: "jpeg",
                quality: 1
            },
            html2canvas: {
                scale: 2,
                useCORS: true
            },
            jsPDF: {
                unit: "mm",
                format: "a4",
                orientation: "portrait"
            }
        })
        .from(element)
        .save();
};

export default OlympiadClubbingPdf;